<!-- Component for PhotoSwipe gallery -->
<template>
    <div class="simpleGallery">
        <ul class="simpleGallery__list">
            <li class="simpleGallery__item" v-for="(image, index) in imageList" :key="index">
                <figure  class="simpleGallery__figure">
                    <span class="mask"></span>
                    <img :src="image.thumbnail" @click="showPhotoSwipe(index)" alt="" class="rspimg">
                </figure>
            </li>
        </ul>

        <PhotoSwipe :isOpen="isOpen" :items="imageList" :options="options" @close="hidePhotoSwipe" />
    </div>
</template>

<script>
import { PhotoSwipe } from 'v-photoswipe';

export default {
    name: 'simpleGallery',
    components: {
        PhotoSwipe
    },

    data () {
        return {
            isOpen: false,
            isOpenGallery: false,
            options: {
                index: 0
            },
            optionsGallery: {},
            imageList: [
                {
                    src: 'https://picsum.photos/1200/900?image=1031',
                    thumbnail: 'https://picsum.photos/450/253?image=1031',
                    w: 1200,
                    h: 900,
                    title: 'This is dummy caption.'
                },
                {
                    src: 'https://picsum.photos/1200/900?image=1048',
                    thumbnail: 'https://picsum.photos/450/253?image=1048',
                    w: 1200,
                    h: 900,
                    title: 'This is dummy caption.'
                },
                {
                    src: 'https://picsum.photos/1200/900?image=1033',
                    thumbnail: 'https://picsum.photos/450/253?image=1033',
                    w: 1200,
                    h: 900,
                    title: 'This is dummy caption.'
                },
                {
                    src: 'https://picsum.photos/1200/900?image=1019',
                    thumbnail: 'https://picsum.photos/450/253?image=1019',
                    w: 1200,
                    h: 900,
                    title: 'This is dummy caption.'
                },
                {
                    src: 'https://picsum.photos/1200/900?image=1026',
                    thumbnail: 'https://picsum.photos/450/253?image=1026',
                    w: 1200,
                    h: 900,
                    title: 'This is dummy caption.'
                },
                {
                    src: 'https://picsum.photos/1200/900?image=1015',
                    thumbnail: 'https://picsum.photos/450/253?image=1015',
                    w: 1200,
                    h: 900,
                    title: 'This is dummy caption.'
                },
            ]
        }
    },
    methods: {
        showPhotoSwipe (index) {
            this.isOpen = true
            this.$set(this.options, 'index', index)
        },
        hidePhotoSwipe () {
            this.isOpen = false
        },
        getImages() {
          fetch('https://next.json-generator.com/api/json/get/NyL0M8ZGD')
            .then(response => response.json())
            .then(data => (this.imageList = data));
        }
    },

    created: function() {
        // this.getImages();
    }
};
</script>

<style scoped lang="scss">
    @import "@/scss/modules/_simpleGallery.scss";
</style>